var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-6"},[_c('v-row',[_c('v-col',{attrs:{"cols":"8"}},[_c('UserProfileCard')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }